import { useState, useEffect, memo } from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../components/common/StyledToolTip";
import styles from "./styles";
const DEFAULT_TITLE = "Merge Stops";

const MergeStops = (props) => {
  const [enable, setEnable] = useState(false);
  const [message, setMessage] = useState(DEFAULT_TITLE);
  useEffect(() => {
    props.eventHub.on(`${props.headerId}_EnableMergeStops`, enableMergeStops);
    return () => {
      props.eventHub.off(
        `${props.headerId}_EnableMergeStops`,
        enableMergeStops
      );
    };
  }, [props.eventHub, props.headerId]);

  const enableMergeStops = ({ enableMerge, message }) => {
    setMessage(message || DEFAULT_TITLE);
    setEnable(enableMerge);
  };

  const mergeStops = () => {
    if (enable) {
      props.eventHub.emit(`${props.headerId}_mergeStops`);
    }
  };

  const { classes } = props;

  return (
    <div
      className={`${classes.headerIconStyles} ${
        classes.iconLayout
      } glHeaderIcons ${enable ? classes.enableIcon : classes.disableIcon}`}
      onClick={mergeStops}
    >
      <Tooltip title={message}>
        <i className={`icon-merge-routes ${classes.actionIcon}`} />
      </Tooltip>
    </div>
  );
};

export default withStyles(styles)(memo(MergeStops));
